import { createContext, useContext, type ReactNode } from 'react';
import type { ModuleRegistry } from './registry.js';

const WidgetModulesContext = createContext<ModuleRegistry | null>(null);

export function WidgetModulesProvider({
  registry,
  children,
}: {
  registry: ModuleRegistry;
  children: ReactNode;
}) {
  return (
    <WidgetModulesContext.Provider value={registry}>
      {children}
    </WidgetModulesContext.Provider>
  );
}

export function useWidgetModules(): ModuleRegistry {
  const registry = useContext(WidgetModulesContext);
  if (!registry) {
    throw new Error('useWidgetModules must be used within WidgetModulesProvider');
  }
  return registry;
}

/** Returns null when the provider is absent (Storybook / isolated components). */
export function useWidgetModulesOptional(): ModuleRegistry | null {
  return useContext(WidgetModulesContext);
}
